import { Injectable } from '@angular/core';
import { medioAmbiente } from '../assets/medioAmbiente.data';
import { saludOcupacional } from '../assets/saludOcupacional.data';
import { medicion } from '../assets/medicion.data';
import { capacitaciones } from '../assets/capacitaciones.data';

@Injectable()
export class DatosService {
  private medioAmbiente: any = medioAmbiente;
  private saludOcupacional: any = saludOcupacional;
  private mediciones: any = medicion;
  private capacitaciones: any = capacitaciones;
  constructor() {}

  getMedioAmbiente() {
    return this.medioAmbiente;
  }

  getSaludOcupacional() {
    return this.saludOcupacional;
  }

  getMediciones() {
    return this.mediciones;
  }

  getCapacitaciones() {
    return this.capacitaciones;
  }

  getElemento(cat: String, id: number): any {
    let t = null;
    let temp = null;
    if (cat === 'mes') {
      temp = this.medioAmbiente;
    }
    if (cat === 'sos') {
      temp = this.saludOcupacional;
    }
    if (cat === 'meds') {
      temp = this.mediciones;
    }
    if (cat === 'caps') {
      temp = this.capacitaciones;
    }

    temp.forEach(element => {
      if (element.id === id) {
        t = element;
      }
    });
    return t;
  }
}



// WEBPACK FOOTER //
// G:/proyectos/website - IntergraMAI/webMai/src/app/datos.service.ts